import { AxiosResponse } from 'axios';
import api from './Api'

export const getAllPaidHistoryByMemberIdAndPaidDateTimeBetween = (memberId: string, startDateTime: string, endDateTime: string): Promise<AxiosResponse<IPaidHistoryBasicWebResponseV2[]>> => {
    return api.get(`/paid-history/my/web/v2/${memberId}?startDateTime=${encodeURIComponent(startDateTime)}&endDateTime=${encodeURIComponent(endDateTime)}`)
}

export const getAllPaidHistoryByMemberIdV3 = (memberId: string) => {
    return api.get<IPaidHistoryV3[]>(`/paid-history/my/web/v3/${memberId}`)
}


export const getPaidHistoryByIssuedWellnessTicketId = (issuedWellnessTicketId: string): Promise<AxiosResponse<IPaidHistoryDetailWebResponseV2>> => {
    return api.get(`/paid-history/my/detail/web/v2/${issuedWellnessTicketId}`)
}